module.exports = __webpack_public_path__ + "img/arrow_back.8b9043cc.svg";